<template>
  <div>
    <vue-element-loading :active="loader.label.active" :text="loader.label.text" />
    <b-card>
      <template #header>
        <b-form-checkbox v-model="labelIntegration.enabled" switch>
          <span>Enable Integration</span>
        </b-form-checkbox>

        <b-icon
          icon="question-square"
          title="Download tutorial"
          scale="1.5"
          class="ml-auto cursor-pointer"
          variant="primary"
          @click="downloadTutorial"
        />
      </template>
      <template #default>
        <b-row>
          <b-col md="6">
            <div class="d-flex flex-column h-100">
              <b-form-group label-cols-md="3" label="Label">
                <v-select v-model="labelIntegration.labelData" :options="parameter.labelList" label="provider" />
              </b-form-group>
              <div v-if="labelIntegration.labelData">
                <b-form-group
                  v-for="f in labelIntegration.labelData.fields"
                  :key="f.key"
                  :label="f.desc"
                  label-cols-md="3"
                >
                  <b-input-group>
                    <b-form-input v-model="f.value" trim :state="f.value !== null && f.value !== ``" />
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
          </b-col>
          <b-col md="6">
            <div class="d-flex flex-column h-100">
              <b-form-group label-cols-md="3" label="Registrar">
                <v-select
                  v-model="labelIntegration.registrarData"
                  :options="parameter.registrarList"
                  label="provider"
                />
              </b-form-group>
              <div v-if="labelIntegration.registrarData">
                <b-form-group
                  v-for="f in labelIntegration.registrarData.fields.filter(f => f.isCredential)"
                  :key="f.key"
                  label-cols-md="3"
                  :label="f.desc"
                >
                  <b-input-group v-if="f.isCredential">
                    <b-form-input v-model="f.value" trim :state="f.value !== null && f.value !== ``" />
                    <template>
                      <b-form-input v-if="f.key == `domainPattern`" v-model="f.value" />
                    </template>
                  </b-input-group>
                </b-form-group>
                <b-form-group label-cols-md="3" label="Domain Pattern">
                  <b-input-group>
                    <b-form-input
                      v-model="labelIntegration.registrarData.fields.find(f => f.key === 'domainPattern').value"
                      trim
                      :state="
                        labelIntegration.registrarData.fields.find(f => f.key === 'domainPattern').value !== null &&
                        labelIntegration.registrarData.fields.find(f => f.key === 'domainPattern').value !== ``
                      "
                    />
                    <template #append>
                      <b-form-select
                        v-model="labelIntegration.registrarData.fields.find(f => f.key === 'domainTld').value"
                        :options="parameter.tldList"
                        :state="
                          labelIntegration.registrarData.fields.find(f => f.key === 'domainTld').value !== null &&
                          labelIntegration.registrarData.fields.find(f => f.key === 'domainTld').value !== ``
                        "
                      ></b-form-select>
                    </template>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
          </b-col>
        </b-row>
      </template>
      <template #footer>
        <b-button variant="success" block @click.stop="saveLabelIntegration"> Save Label Integration </b-button>
      </template>
    </b-card>
  </div>
</template>

<script>
import api from "@api";

export default {
  name: `LabelIntegration`,

  props: {
    clientCode: {
      type: String,
      required: true,
    },
    slotCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      parameter: {
        labelList: [
          {
            provider: `Nexus`,
            fields: [
              { key: `panelUrl`, desc: `Panel URL`, value: null },
              { key: `username`, desc: `Username`, value: null },
              { key: `password`, desc: `Password`, value: null },
            ],
          },
        ],
        registrarList: [
          {
            provider: `Namecheap`,
            fields: [
              { key: `apiUser`, desc: `ApiUser`, value: null, isCredential: true },
              { key: `apiKey`, desc: `ApiKey`, value: null, isCredential: true },
              { key: `username`, desc: `Username`, value: null, isCredential: true },
              { key: `domainPattern`, desc: `Domain Pattern`, value: null, isCredential: false },
              { key: `domainTld`, desc: `Domain TLD`, value: null, isCredential: false },
            ],
          },
        ],
        tldList: [
          { value: `com`, text: `.com` },
          { value: `net`, text: `.net` },
          { value: `org`, text: `.org` },
          { value: `me`, text: `.me` },
          { value: `lol`, text: `.lol` },
          { value: `app`, text: `.app` },
          { value: `xyz`, text: `.xyz` },
          { value: `site`, text: `.site` },
          { value: `online`, text: `.online` },
          { value: `store`, text: `.store` },
          { value: `cyou`, text: `.cyou` },
          { value: `hair`, text: `.hair` },
          { value: `website`, text: `.website` },
          { value: `store`, text: `.store` },
          { value: `shop`, text: `.shop` },
          { value: `quest`, text: `.quest` },
          { value: `click`, text: `.click` },
          { value: `cfd`, text: `.cfd` },
          { value: `autos`, text: `.autos` },
          { value: `makeup`, text: `.makeup` },
          { value: `boats`, text: `.boats` },
          { value: `motorcycles`, text: `.motorcycles` },
          { value: `sbs`, text: `.sbs` },
          { value: `baby`, text: `.baby` },
          { value: `art`, text: `.art` },
        ],
      },
      labelIntegration: {
        enabled: false,
        registrarData: null,
        loaderRegistrar: false,
        labelData: null,
        loaderLabel: false,
      },
      loader: {
        label: {
          text: ``,
          active: false,
        },
      },
      modal: {
        labelIntegrationHelp: false,
      },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    downloadTutorial() {
      alert(`download tutorial`);
    },
    async loadData() {
      var data = await api.get(`slot/integration/label/${this.slotCode}`);

      if (data.labelData != null && data.registrarData != null) {
        this.labelIntegration.enabled = data.labelEnabled;
        var labelData = this.safeJsonParse(data.labelData);
        var registrarData = this.safeJsonParse(data.registrarData);

        const defaultLabelData = this.parameter.labelList.find(label => label.provider === labelData.provider);
        const defaultRegistrarData = this.parameter.registrarList.find(
          registrar => registrar.provider === registrarData.provider,
        );

        defaultLabelData.fields.forEach(field => {
          var value = labelData.fields.find(dataField => dataField.key === field.key).value;
          field.value = value;
        });

        this.labelIntegration.labelData = defaultLabelData;

        defaultRegistrarData.fields.forEach(field => {
          var value = registrarData.fields.find(dataField => dataField.key === field.key).value;
          field.value = value;
        });

        this.labelIntegration.registrarData = defaultRegistrarData;
      }
    },
    async validateLabel() {
      try {
        var result = await api.post(`integration/validation/label`, this.labelIntegration.labelData);
        return result;
      } catch (error) {
        throw error;
      }
    },
    async validateRegistrar() {
      try {
        var result = await api.post(`integration/validation/registrar`, this.labelIntegration.registrarData);
        return result;
      } catch (error) {
        throw error;
      }
    },
    async saveLabelIntegration() {
      if (this.labelIntegration.enabled) {
        let labelFields = Object.values(this.labelIntegration.labelData.fields).filter(
          x => x.value == null || x.value == "",
        );

        if (labelFields.length > 0) {
          this.showToast(`error`, `Please fill all the LABEL INTEGRATION fields`);
          return;
        }

        let registrarFields = Object.values(this.labelIntegration.labelData.fields).filter(
          x => x.value == null || x.value == "",
        );

        if (registrarFields.length > 0) {
          this.showToast(`error`, `Please fill all the REGISTRAR INTEGRATION fields`);
          return;
        }
      }

      this.loader.label.active = true;

      try {
        if (this.labelIntegration.enabled) {
          this.loader.label.text = `Validate Label Credential Data...`;
          let labelValidated = await this.validateLabel();
          if (!labelValidated) {
            this.showToast(`error`, `Label Credential Data is not valid`);
            return;
          }

          this.loader.label.text = `Validate Registrar Credential Data...`;
          let registrarValidated = await this.validateRegistrar();
          if (!registrarValidated) {
            this.showToast(`error`, `Registrar Credential Data is not valid`);
            return;
          }
        }

        this.loader.label.text = `Saving Label Integration...`;
        await api.post(`slot/integration/label`, {
          labelEnabled: this.labelIntegration.enabled,
          labelData: this.labelIntegration.labelData,
          registrarData: this.labelIntegration.registrarData,
          slotCode: this.slotCode,
        });
        this.loader.label.text = `Saved Successfully`;
        this.showToast(`success`, `Label Integration Saved Successfully`);
        this.$emit(`onSaveSuccess`);
      } catch (error) {
        this.showToast(`error`, error);
      } finally {
        this.loader.label.active = false;
      }
    },

    safeJsonParse(jsonString) {
      try {
        return JSON.parse(jsonString);
      } catch (error) {
        console.error("Error parsing JSON:", error);
        return null;
      }
    },
  },
};
</script>
